import { render, staticRenderFns } from "./Config4g.vue?vue&type=template&id=551d7c18&scoped=true&"
import script from "./Config4g.vue?vue&type=script&lang=js&"
export * from "./Config4g.vue?vue&type=script&lang=js&"
import style0 from "./Config4g.vue?vue&type=style&index=0&id=551d7c18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d7c18",
  null
  
)

export default component.exports